<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none">
    <circle
      cx="40"
      cy="40"
      r="39.75"
      fill="white"
      stroke="#BABABF"
      stroke-width="0.5"/>
    <path
      d="M22.5521 42.0842L22.988 41.6718L22.5521 42.0842L38.8413 59.3017L39.2596 59.7438L39.6957 59.3191L56.8455 42.6178C59.0787 40.5757 60.6 37.5681 60.6 34.031C60.6 27.8186 55.8285 22.7337 49.7831 22.7337C45.3907 22.7337 41.6506 25.4662 39.9658 29.444C38.3238 25.4581 34.5034 22.7337 30.1205 22.7337C24.1679 22.7337 19.4 27.8224 19.4 34.031C19.4 37.1311 20.5138 39.9298 22.4557 41.9823L22.5521 42.0842Z"
      fill="#850D54"
      stroke="#850D54"
      stroke-width="1.2"
      stroke-miterlimit="10"/>
  </svg>
</template>
